import { throttle } from 'lodash-es'
import { ref, onBeforeUnmount, onMounted } from '@vue/composition-api'
export const useTableAffix = (tableRef, fixedTop) => {
  const fixedLeftEl = ref(null)
  const fixedRightEl = ref(null)
  const hasFixedCol = ref(false)
  const tableHeaderEl = ref(null)

  const initTableFixed = () => {
    const isBool = typeof fixedTop.value === 'boolean'
    if (isBool && !fixedTop.value.top) {
      return
    }

    const tableEl = tableRef.value.$el
    const headerWrapperEl = tableEl.querySelector('.el-table__header-wrapper')
    headerWrapperEl.style.position = 'sticky'
    headerWrapperEl.style.fontWeight = 500
    headerWrapperEl.style.top = `${fixedTop.value.top}px`
    const headerEl = headerWrapperEl.querySelector('.el-table__header')
    tableHeaderEl.value = headerEl

    if (!tableEl || !headerWrapperEl) {
      return
    }

    const time = setTimeout(() => {
      const fixHeaderRightWrap = tableEl.querySelector('.el-table__fixed-right')
      const fixHeaderLeftWrap = tableEl.querySelector('.el-table__fixed')
      const list = [fixHeaderLeftWrap, fixHeaderRightWrap]
      hasFixedCol.value = list.some((el) => !!el)
      list.forEach((fixHeaderWrap, index) => {
        if (!fixHeaderWrap) {
          return
        }
        const cloneHeaderContainerEl = fixHeaderWrap.cloneNode(false)
        cloneHeaderContainerEl.style.height = 'auto'
        const fixedheaderWrapperEl = fixHeaderWrap.querySelector('.el-table__fixed-header-wrapper')
        cloneHeaderContainerEl.appendChild(fixedheaderWrapperEl)

        if (index === 0) {
          headerWrapperEl.insertBefore(cloneHeaderContainerEl, headerWrapperEl.firstChild)
          headerEl.style['margin-left'] = `-${cloneHeaderContainerEl.style.width}`
          fixedLeftEl.value = cloneHeaderContainerEl
        } else {
          headerWrapperEl.appendChild(cloneHeaderContainerEl)
          fixedRightEl.value = cloneHeaderContainerEl
        }
      })

      if (hasFixedCol.value) {
        headerWrapperEl.style.display = 'flex'
        window.addEventListener(
          'resize',
          throttle(handleResize, 500, {
            trailing: true,
            leading: false
          })
        )
      }
      clearTimeout(time)
    }, 0)
  }
  function handleResize() {
    const tableEl = tableRef.value.$el

    const list = [fixedLeftEl.value, fixedRightEl.value]
    list.forEach((fixedEl, index) => {
      if (!fixedEl) {
        return
      }

      let fixWrapper = null
      if (index === 0) {
        fixWrapper = tableEl.querySelector(':scope >.el-table__fixed')
      } else {
        fixWrapper = tableEl.querySelector(':scope >.el-table__fixed-right')
      }

      if (!fixWrapper) {
        return
      }
      const currentWidth = fixedEl.style.width
      const wrapperWidth = fixWrapper.style.width
      if (!!wrapperWidth && wrapperWidth !== currentWidth) {
        fixedEl.style.width = wrapperWidth
        if (index === 0 && this.tableHeaderEl) {
          this.tableHeaderEl.style['margin-left'] = `-${wrapperWidth}`
        }
      }
    })
  }
  const setHeaderTop = (isFullScreen = false) => {
    const header = document.querySelector('.el-table__header-wrapper')
    if (!header) {
      return
    }
    if (isFullScreen) {
      header.style.top = 0
    } else {
      header.style.top = fixedTop.value.top + 'px'
    }
  }
  onMounted(() => {
    initTableFixed()
    if (tableRef.value) {
      tableRef.value.doLayout()
    }
  })
  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize)
  })
  return {
    initTableFixed,
    setHeaderTop,
    handleResize
  }
}
